<template>
  <b-button variant="warning" type="button" class="float-left" @click.prevent="onClick">Cancel</b-button>
</template>
<script>
  export default {
    props: {
      isMarginLeft: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    methods: {
      onClick () {
        window.goBack(this)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Buttons/Cancel.vue